export const CAMPAIGN_WIZARD_SESSION_ID = 'CAMPAIGN_WIZARD_SESSION_ID';
export const EXPORT_TO_SALESFORCE = 'EXPORT_TO_SALESFORCE';
export const CLICK_CREATE_CAMPAIGN = 'CLICK_CREATE_CAMPAIGN';
export const TELEMETRY_SUCCESS = 'TELEMETRY_SUCCESS';
